import { pluralize } from "@/components/helpers/string-utils";
import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { formatDate } from "@/utils/datetime";

const DEFAULT_DATE_TIME_FORMAT = "MMM d, yyyy 'at' h:mm a";

function getDateTimeString(
  time: Date | string | null | undefined,
  formatString: string,
): { fullDateTime: string; displayText: string } {
  let fullDateTime = "Invalid Date";
  let displayText = "Invalid Date";

  if (!time) return { fullDateTime, displayText };

  fullDateTime = formatDate(time, DEFAULT_DATE_TIME_FORMAT)!;
  displayText = formatDate(time, formatString)!;

  return { fullDateTime, displayText };
}

interface DateTimeDisplayProps {
  formatString?: string;
  time?: string | null;
  showDuration?: boolean;
  duration?: number;
}

export function DateTimeDisplay({
  formatString = DEFAULT_DATE_TIME_FORMAT,
  time,
  showDuration,
  duration,
}: DateTimeDisplayProps) {
  const { fullDateTime, displayText } = getDateTimeString(time, formatString);

  const text =
    showDuration && duration
      ? `${displayText} ・ ${pluralize({
          amount: Math.round(duration),
          singular: "min",
          plural: "mins",
        })}`
      : displayText;

  return (
    <Tooltip content={fullDateTime} placement="top" usePortal={true}>
      {text}
    </Tooltip>
  );
}
